/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'warning-box',
    templateUrl: './warning-box.component.html',
    styles: [
        `
      .warning-box {
        font-weight: bold;
        color: rgb(199, 119, 0);
        background-color: #ffffff;
        padding: 5px 10px;
        margin-bottom: 3px;
        margin-top: 10px;
      }
    
      .warning-box mat-icon {
        margin-right: 15px;
        margin-left: 15px;
      }
    `,
    ],
    standalone: false
})
export class WarningBoxComponent implements OnInit {
  @Input() message = '';
  constructor() {}
  
  ngOnInit() {}
}
